import { axiosInstance } from "@/axios/interceptors";

export default {
  // announceList: (data: AnnounceListParam) => axiosInstance.get("/api/member/notice/list", { params: data }),

  getMainCode: async () => {
    return await axiosInstance.get(`codes`,);
  },
  getSelectedCode: async (code:string) => {
    return await axiosInstance.get(`codes/${code}`);
  },
};
